import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { MinimumFeesFilterState } from '../../hooks/useMinimumFeesMain';
import { MinimumFeesFiltersPanel } from './MinimumFeesFiltersPanel';

interface FiltersSectionProps {
  filters: MinimumFeesFilterState;
  onFiltersChange: (nextFilters: Partial<MinimumFeesFilterState>) => void;
  onClearFilters: () => void;
  activeFiltersCount: number;
  columns: ColumnDef<any>[];
  selectedColumns: string[];
  onColumnsChange: (newSelected: string[]) => void;
}

export const FiltersSection = ({
  filters,
  onFiltersChange,
  onClearFilters,
  activeFiltersCount,
  columns,
  selectedColumns,
  onColumnsChange,
}: FiltersSectionProps) => {
  const { t } = useTranslation('minimumFeesModule');

  return (
    <>
      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        triggerLabel={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="minimum-fees-filters-toggle"
      >
        <MinimumFeesFiltersPanel filters={filters} onChange={onFiltersChange} onClear={onClearFilters} />
      </FiltersDropdown>
      <ColumnSelector
        columns={columns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        storageKey="minimum-fees-columns"
      />
    </>
  );
};
